// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { useEffect } from 'react';

import { getSharedBffWebSocket } from '@/services/bffWebSocket';
import type { BffWebSocketClient } from '@/services/bffWebSocket';

type UseHoleRealtimeParams = {
  apiBaseUrl: string;
  userToken?: string | null;
  claimClientId?: string | null;
  allowAnonymous?: boolean;
  setSocketClient: (client: BffWebSocketClient | null) => void;
};

export const useHoleRealtime = ({
  apiBaseUrl,
  userToken,
  claimClientId,
  allowAnonymous,
  setSocketClient,
}: UseHoleRealtimeParams) => {
  useEffect(() => {
    const socket = getSharedBffWebSocket(apiBaseUrl);
    socket.setClaimClientId(claimClientId ?? null);
    socket.setAnonymousReadOnly(Boolean(allowAnonymous));
    socket.setAuthToken(userToken ?? null);
    setSocketClient(socket);
  }, [allowAnonymous, apiBaseUrl, claimClientId, setSocketClient, userToken]);
};
